module.exports = "../study/imgs/maps/Kanagawa/S8/Hazard/Beach/Kanagawa_Beach_HadGEM2_RCP85_Now.png";